<template>
  <c-app>
    <c-content>
      <section class="sign u-m-auto">
        <div class="sign__body">
		  <h1 class="sign__title">Iniciar Sesión</h1>
          <p class="sign__text">Ingrese con su cuenta RMGRID</p>
          <c-flash type="danger" closeable="false" v-show="errorMessage != ''">{{ errorMessage }}</c-flash>
          <c-form ref="loginform" id="loginform" action="/Account/Login" method="POST">
			<div v-html="forgeryToken"></div>
			<c-form-field label="Usuario">
              <c-form-input id="UserName" name="UserName" type="username" v-model="Username"></c-form-input>
            </c-form-field>
            <c-form-field label="Contraseña">
              <c-form-input icon-start="icon-lock" id="Password" name="Password"  type="Password" v-model="Password"></c-form-input>
            </c-form-field>
            <c-form-field>
              <c-level>
                <c-form-checkbox label="Recordar" v-model="Remember" slot="left"></c-form-checkbox>
                <router-link to="/forgot" slot="right">Olvidé mi Contraseña?</router-link>
              </c-level>
            </c-form-field>
            <c-button type="primary" @click.prevent="login" block>Iniciar Sesión</c-button>
          </c-form>
		  <div style="text-align:center;">
			<img src="../assets/rmgridlogoBlue.png" alt="rmgrid" style="width:50%;margin-top:20px;">
		  </div>
        </div>
        <footer class="sign__footer u-text-center">
          <!--<p>No tiene Cuenta? <router-link to="/register">Solicite su Cuenta</router-link></p>-->
          <p class="u-text-muted u-fs-12">RMGRID by Riverminds Cia. Ltda.<br>© 2017-2018. Todos los Derechos Reservados.</p>
        </footer>
      </section>
    </c-content>
  </c-app>
</template>

<script>
export default {
  name: "LoginView",
  data() {
	  return {
      forgeryToken: window.forgeryToken,
      baseServiceUrl: window.baseServiceUrl,
      Username: "",
      Password: "",
      Remember: false,
      errorMessage: ""

	  }
  },
  methods: {
    login() {
      const vm = this.$toast.loading("Iniciando Sesión...");

      this.$http.post(baseServiceUrl + 'api/accountapi/login', {
        UserName: this.Username,
        Password: this.Password,
        RememberMe: this.Remember
      }).then(function(response){
        
        vm.hide();
        debugger;
        if (response != null && response.body != null && response.body.PasswordUpdate != null)
        {
          var EmailUpdate = false;
          var DisplayName = "";

          if (response != null && response.body != null && response.body.DisplayName != null)
            DisplayName = response.body.DisplayName;

          if (response != null && response.body != null && response.body.EmailUpdate != null)
            EmailUpdate = response.body.EmailUpdate;

          if (response.body.PasswordUpdate == true)
            this.$router.replace({ name: 'UpdateProfile', params: { propUsername: this.Username, propEmailUpdate: EmailUpdate, propDisplayName: DisplayName } })
          else
            window.location = this.baseServiceUrl;
        }
        else{
          window.location = this.baseServiceUrl;
        }

      }, function(e){
        vm.hide();
        if (e != null && e.body != null && e.body.Message != null)
        {
          this.errorMessage = e.body.Message;
        }

      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/login.vue